import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { AppShell } from '@/components/layout/AppShell';
import { ErrorBoundary } from '@/components/feedback/ErrorBoundary';
import { PermissionNoticeHost } from '@/components/feedback/PermissionNoticeHost';
import type { NavGroup } from '@/shared/types/navigation';
import { adminNavigationGroups } from './AdminNavigation';

export function AdminLayout() {
  const { t } = useTranslation('common');
  const { pathname } = useLocation();

  // PRD 21 §4.5 / PRD 22 §2.2.2: LNB menus are shown to ALL roles regardless of
  // permission. Access is enforced per-page (useRequirePermission) — a role that
  // lacks permission still sees the menu but is blocked on entry. The menu items'
  // `permission` tags remain for that per-page enforcement, not for hiding here.
  const navGroups: NavGroup[] = adminNavigationGroups
    .map((group) => ({
      label: group.labelKey ? t(group.labelKey) : '',
      items: group.items.map((item) => ({
        label: t(item.labelKey),
        path: item.path,
        icon: item.icon,
      })),
    }))
    .filter((group) => group.items.length > 0);

  return (
    <AppShell variant="admin" navGroups={navGroups}>
      {/* Per-route boundary: a crash in one screen shows a contained fallback
          while the sidebar/nav stay usable. Keyed by pathname so navigating to
          another menu auto-clears the error. */}
      <ErrorBoundary resetKey={pathname}>
        <Outlet />
      </ErrorBoundary>
      {/* 권한 없음 modal for a page this admin may not open. Mounted here rather than at the app
          root because it needs the router; every gated page sits under this layout. */}
      <PermissionNoticeHost />
    </AppShell>
  );
}
